import { defineMessages } from 'react-intl';

export default defineMessages({
  message: {
    id: 'LogoutPage.message',
    defaultMessage: 'Please give us a bit while we log you out ...',
  },
});
